import { motion } from "framer-motion";
import { MonitorPlay, Laptop, ScreenShare, MessageCircleQuestion, MessageCircle } from "lucide-react";
import { IMAGES, ONLINE_WHATSAPP, ONLINE_JOIN_POINTS } from "@/lib/content";
import { Reveal } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

const pointIcons = [Laptop, ScreenShare, MessageCircleQuestion];

export const OnlineJoin = () => (
  <section className="relative px-4 py-16 sm:px-8 lg:py-24" data-testid="online-join-section">
    <div className="mx-auto max-w-6xl">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-em2/35 bg-surface glow-emerald">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-em1/15 blur-[90px] animate-glow-pulse" />
          <div className="grid lg:grid-cols-2">
            <div className="relative z-10 p-7 sm:p-10">
              <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-ink px-3 py-1 text-xs font-bold uppercase tracking-wider text-gold">
                <MonitorPlay size={13} /> 100% Online
              </span>
              <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-5xl">
                Attend From Your Phone or Laptop.{" "}
                <span className="text-em2">No Commute, No Pressure.</span>
              </h2>
              <p className="mt-3 text-base text-mutedgreen">
                Live mentors. Live markets. Built around your schedule, wherever you are.
              </p>

              <div className="mt-6 rounded-2xl border border-surfaceline bg-ink/60 p-5">
                <p className="font-semibold text-offwhite">BullsEdge Academy</p>
                <p className="text-sm leading-relaxed text-mutedgreen">
                  Live Online Classes via Zoom &amp; Google Meet
                </p>
                <p className="text-sm leading-relaxed text-mutedgreen">
                  Recordings after every session
                </p>
              </div>

              <ul className="mt-5 space-y-2.5">
                {ONLINE_JOIN_POINTS.map((text, i) => {
                  const Icon = pointIcons[i];
                  return (
                    <li key={text} className="flex items-start gap-2.5 text-sm text-offwhite">
                      <Icon size={16} strokeWidth={1.6} className="mt-0.5 shrink-0 text-em2" />
                      {text}
                    </li>
                  );
                })}
              </ul>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <EligibilityButton
                  size="md"
                  label="Book Free Demo"
                  testId="online-join-demo-btn"
                  className="flex-1"
                />
                <a
                  href={ONLINE_WHATSAPP}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="online-join-whatsapp-btn"
                  className="inline-flex min-h-[52px] flex-1 items-center justify-center gap-2 rounded-full border border-em2/40 bg-em2/10 px-6 font-semibold text-em2 transition-colors hover:bg-em2/20"
                >
                  <MessageCircle size={18} /> WhatsApp Us
                </a>
              </div>
            </div>

            <div className="relative min-h-[240px] lg:min-h-full">
              <img
                src={IMAGES.tradingDesk}
                alt="Online trading desk setup with live market screens"
                className="absolute inset-0 h-full w-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/40 to-transparent lg:bg-gradient-to-r" />
              <motion.div
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ type: "spring", damping: 15 }}
                className="btn-emerald absolute bottom-5 right-5 flex h-14 w-14 items-center justify-center rounded-full text-white"
              >
                <MonitorPlay size={26} />
              </motion.div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
